import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import App from './App';
import { observeCameraPermissionPrompt } from './utils/cameraPermissionPrompt';
import { initYandexMetrika } from './utils/yandexMetrika';
import { initMatomo } from './utils/matomo';
import 'mind-ar/dist/mindar-image-aframe.prod';
import 'aframe-troika-text';

observeCameraPermissionPrompt();
initYandexMetrika();
initMatomo();

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
